import { render, staticRenderFns } from "./FamilyMemberHistory.vue?vue&type=template&id=75e27d80&scoped=true&"
import script from "./FamilyMemberHistory.vue?vue&type=script&lang=js&"
export * from "./FamilyMemberHistory.vue?vue&type=script&lang=js&"
import style0 from "./FamilyMemberHistory.vue?vue&type=style&index=0&id=75e27d80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e27d80",
  null
  
)

export default component.exports